export const environment = {
  production: true,
  msalConfig: {
    auth: {
      clientId: '274e7856-31d5-4ac7-b352-965795589c73',
      authority: 'https://login.microsoftonline.com/46fcfae0-42ab-4636-89c7-d6f7305ad74e',
      redirectUri: 'https://pensiontool.nwmo.ca',
      postLogoutRedirectUri: 'https://pensiontool.nwmo.ca',
      navigateToLoginRequestUrl: true
    }
  },
  apiConfig: {
    scopes: ['api://274e7856-31d5-4ac7-b352-965795589c73/Files.Read'],
    uri: '/api/'
  },
  msGraphApiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  },
  apiBaseUrlPrefix: 'https://nwmo-api-prod.azurewebsites.net/api',
  NWMOrestricted: 'true'
};
